import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import { getLogoInfo } from "../redux/action/club/club";

const HeaderLogo = () => {

    const dispatch = useDispatch()


    const { logo } = useSelector((state) => state.club)


    useEffect(() => {
        if (!logo) {
            dispatch(getLogoInfo())
        }
    }, [dispatch, logo]);



    return (
        <>
            <div class="brand__logo">
                <Link to="/">
                    <img
                        src={logo?.image ? `${process.env.REACT_APP_SERVER}/${logo.image}` : "/images/Logo-plc.png"}
                        alt="Parsippany Lions Club"
                        loading="lazy"
                    ></img>
                </Link>
            </div>
        </>
    );
};

export default HeaderLogo;
